export function refreshPage() {
  window.location.reload(true);
}

export const openExternalUrlInNewTab = (url) => {
  window.open(url, "_blank").focus();
};
